import { useState } from 'react';

// The caller owns logout side effects (including leaving a room). This hook
// only coordinates confirmation and the pending state shared by both menus.
export const useLogoutConfirmation = (onLogout) => {
    const [loggingOut, setLoggingOut] = useState(false);
    const [showLogoutConfirmation, setShowLogoutConfirmation] = useState(false);

    const handleLogout = async () => {
        if (loggingOut) return;
        setLoggingOut(true);
        setShowLogoutConfirmation(false);
        try {
            await onLogout();
        } finally {
            setLoggingOut(false);
        }
    };

    return { loggingOut, showLogoutConfirmation, setShowLogoutConfirmation, handleLogout };
};
